import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  GET_ALL_BANNERS,
  CREATE_BANNER,
  UPDATE_BANNER,
  DELETE_BANNER,
} from "./actionTypes"
import {
  getAllBannersCall,
  createBannerCall,
  updateBannerCall,
  deleteBannerCall,
  API_URL,
} from "../../helpers/repository"
import { getAllBanners, getAllBannersResponseSuccess } from "./actions"
import { showErrorMessages } from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "store/actions"

function* attemptGetAllBanners() {
  try {
    const response = yield call(getAllBannersCall)
    yield put(getAllBannersResponseSuccess(response.data.data))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreateBanner(action) {
  const { history } = action
  try {
    const response = yield call(createBannerCall, action.payload)
    showMessage("success", response.data.message)
    history.push("/crm/content")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptEditBanner(action) {
  const { history, id } = action
  try {
    const response = yield call(updateBannerCall, action.payload, id)
    showMessage("success", response.data.message)
    yield put(getAllBanners())
    history.push(`/crm/content`)
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------DELETE------------------------------------------------------
function* attemptDeleteBanner(action) {
  try {
    const response = yield call(deleteBannerCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllBanners())
  } catch (error) {
    showErrorMessages(error)
  }
}

function* ContentSaga() {
  yield takeEvery(GET_ALL_BANNERS, attemptGetAllBanners)
  yield takeEvery(CREATE_BANNER, attemptCreateBanner)
  yield takeEvery(UPDATE_BANNER, attemptEditBanner)
  yield takeEvery(DELETE_BANNER, attemptDeleteBanner)
}

export default ContentSaga
